import React from 'react';
import PropTypes from 'prop-types';

class Alert extends React.Component {

    constructor(props) {
        super(props);
        this.contentRef = React.createRef();
        this.state = {
            height: 0
        };
    }

    componentDidMount() {
        if (!this.props.isSticky) {
            window.addEventListener("resize", this.setHeight);
            this.setHeight();
        }
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.setHeight);
    }

    setHeight = () => {
        let height = this.contentRef.current.clientHeight;
        this.setState({ height });
    }

    getAlertClass = () => {
        let c = "aui-alert aui-js-alert " + this.props.className;
        let openClass = "is-closed";
        if (this.props.isOpen) {
            openClass = "is-open";
        }
        c += ` ${openClass}`;
        if (this.props.isSticky) {
            c += " aui-alert--sticky";
        }
        let bgColour = "aui-color-white";
        let textColour = "";
        if (this.props.variant) {
            textColour = `aui-color-text-${this.props.variant}`;
        }
        if (this.props.reverseColour) {
            bgColour = "aui-color-black";
            textColour = "aui-color-text-light";
            if (this.props.variant) {
                bgColour = `aui-color-${this.props.variant}`;
            }
        }
        c += ` ${bgColour} ${textColour}`;
        return c;
    }

    render() {
        let _style = Object.assign({}, this.props.style, {height: `${this.state.height}px`});
        return (
            <div className={this.getAlertClass()} role="alert" style={_style}>
                <div className="aui-alert__content" ref={this.contentRef}>
                    {this.props.children}
                    <button type="button" className="aui-alert__close" onClick={this.props.onClose} />
                </div>
            </div>
        );
    }

}

Alert.propTypes = {
    children: PropTypes.node,
    isOpen: PropTypes.bool,
    isSticky: PropTypes.bool,
    variant: PropTypes.oneOf(['success', 'warning', 'danger']),
    reverseColour: PropTypes.bool,
    onClose: PropTypes.func, // should set the isOpen prop to false
    style: PropTypes.object,
    className: PropTypes.string
};

Alert.defaultProps = {
    style: {},
    className: ''
}

export default Alert;
